import isEqual from 'lodash/isEqual';

import { isAdSDK2Enabled } from '@wetransfer/transfer/adsdk/helpers/is-adsdk-two-enabled';

// TODO: decrecate this file when adsdk 2.0 is 100% released
export const displayWallpaper = (src: string, href = '', title = ''): void => {
  if (isAdSDK2Enabled()) {
    return;
  }

  const wallpaper = {
    src,
    format: 'image',
    href,
    title,
  };

  // Only update if wallpaper has changed
  if (
    !isEqual(
      wallpaper,
      // TODO remove `any`s when wallpaper SDK types are updated
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window.AdTech.wallpaper.sdkState as any).wallpapers?.[0]
    )
  ) {
    if (window.AdTech?.wallpaper) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window.AdTech.wallpaper.actions as any).updateWallpapers?.([wallpaper]);
      window.AdTech.wallpaper.actions.rotate();
    }
  }
};

export const resetWallpaper = (): void => {
  if (isAdSDK2Enabled()) {
    return;
  }

  // Only reset if custom wallpapers are set
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  if ((window.AdTech.wallpaper?.sdkState as any)?.wallpapers?.length) {
    if (window.AdTech?.wallpaper) {
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (window.AdTech.wallpaper.actions as any).updateWallpapers?.([]);
      window.AdTech.wallpaper.actions.rotate({ force: true });
    }
  }
};
